export default {
  'groupingsAccountPayable.list.header.code': 'Code',
  'groupingsAccountPayable.list.header.description': 'Description',
  'groupingsAccountPayable.list.header.installments': 'Number of Installments',
  'groupingsAccountPayable.list.header.amount': 'Amount',
  'groupingsAccountPayable.list.header.actions': 'Action',

  'groupingsAccountPayable.generate.clusters': 'Generate Clusters',
  'groupingsAccountPayable.generate.searchAccounts': 'Search Accounts',

  'groupingsAccountPayable.form.company': 'Company',
  'groupingsAccountPayable.form.creditor': 'Creditor',
  'groupingsAccountPayable.form.supplier': 'Supplier',
  'groupingsAccountPayable.form.employee': 'Employee',
};
